// its the main code

// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import ProductList from "./Products/ProductList";
// import Taxes from "./Component/Taxes/Taxes";
// // import Payment from "./Component/Payments/Payment";
// import Dashboard from "./Component/main_contant/Dashboard";
// import Invoice from "./Component/Invoices Management/Invoice";
// import User from "./Component/User/User";
// // import Footer from "./Component/Footer/Footer";
// import Signin from "./Authentication/Sign_in/Signin";
// import Signup from "./Authentication/sigin up/Signup";
// import Addinvoice from "./Component/Add invoice/Addinvoice";
// import InvoicesDetails from "./Component/Invoices Details/InvoicesDetails";
// import MasterData from "./Masters/Master/MasterData";
// import Getdata from "./Masters/Master/Getdata";
// import Updatedata from "./Masters/Master/Updatedta";
// import Selectdata from "./Masters/Master/Selectdata";
// import Resetpass from "./Masters/Master/Resetpass";
// import Users from "./Masters/Master/Users/Users";
// import Compney from "./Masters/Companey/Compney";
// import Selectcompny from "./Masters/Companey/Selectcompny";
// import CompUpdateData from "./Masters/Companey/Compupdate";
// import Deletdata from "./Masters/Master/Deletdata";
// import NewUser from "./Masters/Master/Users/NewUser";
// import Updateuser from "./Masters/Master/Users/Updateuser";
// import Servisemaster from "./Masters/Master/Servisemaster";
// import VehicleType from "./Masters/Master/vehile_type/VehicleType";
// import ShowVehicleTypes from "./Masters/Master/vehile_type/Showvehicletype";
// import Fares from "./Masters/Master/Fares/Fares";
// import Showfares from "./Masters/Master/Fares/Showfares";
// import Showservice from "./Masters/Master/Service Master/Showservise";
// import Updateservice from "./Masters/Master/Service Master/Updateservice";
// import Updatefares from "./Masters/Master/Fares/Updatefares";
// import UpdateServiceMast from "./Masters/Master/vehile_type/UpVehicleType";
// import UpdateVehicle from "./Masters/Master/vehile_type/UpVehicleType";
// import GroupMaster from "./Masters/Master/GroupMaster/GroupMaster";
// import AddGroup from "./Masters/Master/GroupMaster/AddGroup";
// import UpdateGroup from "./Masters/Master/GroupMaster/UpdateGroup";
// import ShowLedger from "./Masters/Master/Ledger/ShowLedger";
// import AddLedger from "./Masters/Master/Ledger/AddLedger";
// import UpdateLedger from "./Masters/Master/Ledger/UpdateLedger";
// import Vehicles from "./Masters/Master/Vehicles/Vehicles";
// import AddVehicles from "./Masters/Master/Vehicles/AddVehicles";
// import UpdateVehicles from "./Masters/Master/Vehicles/UpdateVehicles";
// import BillsInvoice from "./Entries/BillsInvoice";

// function Service() {
//   return (
//     <>
//       <Routes>
//         <Route path="/invoicedetails" element={<InvoicesDetails />} />
//         <Route path="/addinvoice" element={<Addinvoice />} />
//         <Route path="/signup" element={<Signup />} />
//         <Route path="/" element={<Signin />} />
//         <Route path="/home" element={<Dashboard />} />
//         <Route path="/invoice" element={<Invoice />} />
//         <Route path="/product" element={<ProductList />} />
//         <Route path="/taxes" element={<Taxes />} />
//         {/* <Route path="/payment" element={<Payment />} /> */}
//         <Route path="/user" element={<User />} />
//         <Route path="/masterdata" element={<MasterData />} />
//         <Route path="/getdata" element={<Getdata />} />
//         <Route path="/updatedata" element={<Updatedata />} />
//         <Route path="/users" element={<Users />} />
//         <Route path="/selectdata" element={<Selectdata />} />
//         <Route path="/resetpass/:id/:name" element={<Resetpass />} />
//         <Route path="/compney" element={<Compney />} />
//         <Route path="/selectcompny" element={<Selectcompny />} />
//         <Route path="/compupdatedata" element={<CompUpdateData />} />
//         <Route path="/deletdata" element={<Deletdata />} />
//         <Route path="/newusers" element={<NewUser />} />
//         <Route path="/updateuser" element={<Updateuser />} />
//         <Route path="/servisemaster" element={<Servisemaster />} />
//         <Route path="/vehicletype" element={<VehicleType />} />
//         <Route path="/showvehicletype" element={<ShowVehicleTypes />} />
//         <Route path="/fares" element={<Fares />} />
//         <Route path="/showfares" element={< Showfares/>} />
//         <Route path="/showservice" element={< Showservice/>} />
//         <Route path="/updateservice" element={<Updateservice/>} />
//         <Route path="/updatefares" element={<Updatefares/>} />
//         <Route path="/updateservicemast" element={<UpdateServiceMast/>} />
//         <Route path="/updatevehile" element={<UpdateVehicle/>} />
//         <Route path="/GroupMaster" element={<GroupMaster />} />
//         <Route path="/AddGroup" element={<AddGroup />} />
//         <Route path="/updategroup" element={<UpdateGroup />} />
//         <Route path="/Ledger" element={<ShowLedger />} />
//         <Route path="/AddLedger" element={<AddLedger />} />
//         <Route path="/ShowLedger" element={<ShowLedger />} />
//         <Route path="/UpdateLedger" element={<UpdateLedger />} />
//         <Route path="/Vehicles" element={<Vehicles />} />
//         <Route path="/AddVehicles" element={<AddVehicles />} />
//         <Route path="/UpdateVehicles" element={<UpdateVehicles />} />
//         <Route path="/BillsInvoice" element={<BillsInvoice />} />

//       </Routes>
//       {/* <Footer/> */}
//     </>
//   );
// }

// export default Service;

// adjust the layout

// import React from "react";
// import { Routes, Route, Outlet } from "react-router-dom";
// import ProductList from "./Products/ProductList";
// import Taxes from "./Component/Taxes/Taxes";
// // import Payment from "./Component/Payments/Payment";
// import Dashboard from "./Component/main_contant/Dashboard";
// import Invoice from "./Component/Invoices Management/Invoice";
// import User from "./Component/User/User";
// // import Footer from "./Component/Footer/Footer";
// import Signin from "./Authentication/Sign_in/Signin";
// import Signup from "./Authentication/sigin up/Signup";
// import Addinvoice from "./Component/Add invoice/Addinvoice";
// import InvoicesDetails from "./Component/Invoices Details/InvoicesDetails";
// import MasterData from "./Masters/Master/MasterData";
// import Getdata from "./Masters/Master/Getdata";
// import Updatedata from "./Masters/Master/Updatedta";
// import Selectdata from "./Masters/Master/Selectdata";
// import Resetpass from "./Masters/Master/Resetpass";
// import Users from "./Masters/Master/Users/Users";
// import Compney from "./Masters/Companey/Compney";
// import Selectcompny from "./Masters/Companey/Selectcompny";
// import CompUpdateData from "./Masters/Companey/Compupdate";
// import Deletdata from "./Masters/Master/Deletdata";
// import NewUser from "./Masters/Master/Users/NewUser";
// import Updateuser from "./Masters/Master/Users/Updateuser";
// import Servisemaster from "./Masters/Master/Servisemaster";
// import VehicleType from "./Masters/Master/vehile_type/VehicleType";
// import ShowVehicleTypes from "./Masters/Master/vehile_type/Showvehicletype";
// import Fares from "./Masters/Master/Fares/Fares";
// import Showfares from "./Masters/Master/Fares/Showfares";
// import Showservice from "./Masters/Master/Service Master/Showservise";
// import Updateservice from "./Masters/Master/Service Master/Updateservice";
// import Updatefares from "./Masters/Master/Fares/Updatefares";
// import UpdateServiceMast from "./Masters/Master/vehile_type/UpVehicleType";
// import UpdateVehicle from "./Masters/Master/vehile_type/UpVehicleType";
// import GroupMaster from "./Masters/Master/GroupMaster/GroupMaster";
// import AddGroup from "./Masters/Master/GroupMaster/AddGroup";
// import UpdateGroup from "./Masters/Master/GroupMaster/UpdateGroup";
// import ShowLedger from "./Masters/Master/Ledger/ShowLedger";
// import AddLedger from "./Masters/Master/Ledger/AddLedger";
// import UpdateLedger from "./Masters/Master/Ledger/UpdateLedger";
// import Vehicles from "./Masters/Master/Vehicles/Vehicles";
// import AddVehicles from "./Masters/Master/Vehicles/AddVehicles";
// import UpdateVehicles from "./Masters/Master/Vehicles/UpdateVehicles";
// import BillsInvoice from "./Entries/BillsInvoice";
// import Navbar from "./Component/Navbar/Navbar";
// import SelectCompany from "./components/Company/SelectCompany";

// const Layout = () => (
//   <>
//     <Navbar />
//     <Outlet />
//   </>
// );

// function Service() {
//   return (
//     <>
//       <Routes>
//         <Route path="/signup" element={<Signup />} />
//         <Route path="/" element={<Signin />} />
//         {/* Company selection page (only if signed in) */}
//           <Route
//             path="/select-company"
//             element={isLoggedIn ? <SelectCompany /> : <Navigate to="/" />}
//           />
//         <Route element={<Layout />}>
//           <Route path="/invoicedetails" element={<InvoicesDetails />} />
//           <Route path="/addinvoice" element={<Addinvoice />} />
//           <Route path="/home" element={<Dashboard />} />
//           <Route path="/invoice" element={<Invoice />} />
//           <Route path="/product" element={<ProductList />} />
//           <Route path="/taxes" element={<Taxes />} />
//           {/* <Route path="/payment" element={<Payment />} /> */}
//           <Route path="/user" element={<User />} />
//           <Route path="/masterdata" element={<MasterData />} />
//           <Route path="/getdata" element={<Getdata />} />
//           <Route path="/updatedata" element={<Updatedata />} />
//           <Route path="/users" element={<Users />} />
//           <Route path="/selectdata" element={<Selectdata />} />
//           <Route path="/resetpass/:id/:name" element={<Resetpass />} />
//           <Route path="/compney" element={<Compney />} />
//           <Route path="/selectcompny" element={<Selectcompny />} />
//           <Route path="/compupdatedata" element={<CompUpdateData />} />
//           <Route path="/deletdata" element={<Deletdata />} />
//           <Route path="/newusers" element={<NewUser />} />
//           <Route path="/updateuser" element={<Updateuser />} />
//           <Route path="/servisemaster" element={<Servisemaster />} />
//           <Route path="/vehicletype" element={<VehicleType />} />
//           <Route path="/showvehicletype" element={<ShowVehicleTypes />} />
//           <Route path="/fares" element={<Fares />} />
//           <Route path="/showfares" element={<Showfares />} />
//           <Route path="/showservice" element={<Showservice />} />
//           <Route path="/updateservice" element={<Updateservice />} />
//           <Route path="/updatefares" element={<Updatefares />} />
//           <Route path="/updateservicemast" element={<UpdateServiceMast />} />
//           <Route path="/updatevehile" element={<UpdateVehicle />} />
//           <Route path="/GroupMaster" element={<GroupMaster />} />
//           <Route path="/AddGroup" element={<AddGroup />} />
//           <Route path="/updategroup" element={<UpdateGroup />} />
//           <Route path="/Ledger" element={<ShowLedger />} />
//           <Route path="/AddLedger" element={<AddLedger />} />
//           <Route path="/ShowLedger" element={<ShowLedger />} />
//           <Route path="/UpdateLedger" element={<UpdateLedger />} />
//           <Route path="/Vehicles" element={<Vehicles />} />
//           <Route path="/AddVehicles" element={<AddVehicles />} />
//           <Route path="/UpdateVehicles" element={<UpdateVehicles />} />
//           <Route path="/BillsInvoice" element={<BillsInvoice />} />
//         </Route>
//       </Routes>
//       {/* <Footer/> */}
//     </>
//   );
// }

// export default Service;

// here add the select company redirect after sign in

import React, { useState, useEffect } from "react";
import { Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import ProductList from "./Products/ProductList";
import Taxes from "./Component/Taxes/Taxes";
// import Payment from "./Component/Payments/Payment";
import Dashboard from "./Component/main_contant/Dashboard";
import Invoice from "./Component/Invoices Management/Invoice";
import User from "./Component/User/User";
import Footer from "./Component/Footer/Footer";
import Signin from "./Authentication/Sign_in/Signin";
import Signup from "./Authentication/sigin up/Signup";
import ForgotPassword from "./Authentication/Forgot_password/ForgotPassword";
import OtpVerification from "./Authentication/Forgot_password/OtpVerification";
import ResetPassword from "./Authentication/Forgot_password/ResetPassword";
import Addinvoice from "./Component/Add invoice/Addinvoice";
import InvoicesDetails from "./Component/Invoices Details/InvoicesDetails";
import MasterData from "./Masters/Master/MasterData";
import Getdata from "./Masters/Master/Getdata";
import Updatedata from "./Masters/Master/Updatedta";
import Selectdata from "./Masters/Master/Selectdata";
import Resetpass from "./Masters/Master/Resetpass";
import Users from "./Masters/Master/Users/Users";
import Compney from "./Masters/Companey/Compney";
import Selectcompny from "./Masters/Companey/Selectcompny";
import CompUpdateData from "./Masters/Companey/Compupdate";
import Deletdata from "./Masters/Master/Deletdata";
import NewUser from "./Masters/Master/Users/NewUser";
import Updateuser from "./Masters/Master/Users/Updateuser";
import Servisemaster from "./Masters/Master/Servisemaster";
import VehicleType from "./Masters/Master/vehile_type/VehicleType";
import ShowVehicleTypes from "./Masters/Master/vehile_type/Showvehicletype";
import Fares from "./Masters/Master/Fares/Fares";
import Showfares from "./Masters/Master/Fares/Showfares";
import Showservice from "./Masters/Master/Service Master/Showservise";
import Updateservice from "./Masters/Master/Service Master/Updateservice";
import Updatefares from "./Masters/Master/Fares/Updatefares";
import UpdateServiceMast from "./Masters/Master/vehile_type/UpVehicleType";
import UpdateVehicle from "./Masters/Master/vehile_type/UpVehicleType";
import GroupMaster from "./Masters/Master/GroupMaster/GroupMaster";
import AddGroup from "./Masters/Master/GroupMaster/AddGroup";
import UpdateGroup from "./Masters/Master/GroupMaster/UpdateGroup";
import ShowLedger from "./Masters/Master/Ledger/ShowLedger";
import AddLedger from "./Masters/Master/Ledger/AddLedger";
import UpdateLedger from "./Masters/Master/Ledger/UpdateLedger";
import Vehicles from "./Masters/Master/Vehicles/Vehicles";
import AddVehicles from "./Masters/Master/Vehicles/AddVehicles";
import UpdateVehicles from "./Masters/Master/Vehicles/UpdateVehicles";
import BillsInvoice from "./Entries/BillsInvoice";
import { Sidebar, Header } from "./Component/Navbar/Navbar";
import SelectCompany from "./Component/Company/Companyselect";
import ViewInvoice from "./Entries/ViewInvoice";
import InvoiceDetails from "./Entries/InvoiceDetails";
import Profile from "./Component/Profile/Profile";
import Booking from "./Booking/Booking";
import DutySlip from "./Booking/Dutyslip";
import GstTaxRegister from "./Component/Reports/GstTaxRegister";
import VoucherRegister from "./Component/Vouchers/VoucherRegister";
import AccountLedgerReport from "./Component/Reports/AccountLedgerReport";
import TrialBalanceReport from "./Component/Reports/TrialBalanceReport";
import VoucherEntry from "./Transactions/VoucherEntry/VoucherEntry";
import MonthlyLedgerSummary from "./Reports/MonthlyLedgerSummary/MonthlyLedgerSummary";
import LedgerTransactions from "./Reports/LedgerTransactions/LedgerTransactions";
import GroupLedgerSummary from "./Reports/GroupLedgerSummary/GroupLedgerSummary";
import GroupSummary from "./Reports/GroupSummary/GroupSummary";
import JournalRegister from "./Reports/JournalRegister/JournalRegister";
import DayBook from "./Reports/DayBook/DayBook";
import CashBook from "./Reports/CashBook/CashBook";
import BankBook from "./Reports/BankBook/BankBook";
import PurchaseRegister from "./Reports/PurchaseRegister/PurchaseRegister";
import SalesRegister from "./Reports/SalesRegister/SalesRegister";
import ProfitLoss from "./Reports/ProfitLoss/ProfitLoss";
import BalanceSheet from "./Reports/BalanceSheet/BalanceSheet";
import Configuration from "./Component/Configuration/Configuration";
import ImportLedger from "./Component/ImportLedger/ImportLedger";

// ✅ Import CompanyContext
import { CompanyProvider } from "./context/CompanyContext";
import "./Layout.css";
import "./responsive.css";

const Layout = () => {
  // Auto-collapse when on smaller laptop screens/tablets (<= 1024px)
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth <= 1024;
    }
    return false;
  });

  // Dynamically adapt to screen resize and window split
  useEffect(() => {
    let lastWidth = window.innerWidth;
    const handleResize = () => {
      const currentWidth = window.innerWidth;
      if (currentWidth <= 1024 && lastWidth > 1024) {
        setCollapsed(true);
      }
      lastWidth = currentWidth;
    };

    const handleKeyDown = (e) => {
      // Shortcut Ctrl+B or Cmd+B to toggle sidebar on desktop / laptop
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "b") {
        e.preventDefault();
        setCollapsed((prev) => !prev);
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className={`layout-container ${collapsed ? "sidebar-collapsed" : ""}`}>
      {/* Backdrop overlay for small / split screens when sidebar drawer is open */}
      {!collapsed && (
        <div
          className="sidebar_mobile_backdrop"
          onClick={() => setCollapsed(true)}
          title="Click to close sidebar drawer"
          aria-hidden="true"
        />
      )}

      {/* Sidebar on left */}
      <Sidebar admin={collapsed} setadmin={setCollapsed} />

      {/* Main dashboard area with Top Header */}
      <div className="layout-content">
        <Header admin={collapsed} setadmin={setCollapsed} />
        <div className="layout-page-content">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
};

//     <div className="layout-container">
//       {/* ===== Sidebar ===== */}
//       <div className="layout-sidebar">
//         {/* Sidebar content here (menu, icons, etc.) */}
//       </div>

//       {/* ===== Main Dashboard Area ===== */}
//       <div className="main-content">
//         {/* ✅ Navbar on top */}
//         <Navbar />

//         {/* ✅ Page Content */}
//         <div className="page-content">
//           <Outlet />
//         </div>
//       </div>
//     </div>
//   );
const ROUTE_TITLES = {
  "/": "Sign In",
  "/signup": "Sign Up",
  "/forgot-password": "Forgot Password",
  "/verify-otp": "Verify OTP",
  "/reset-password": "Reset Password",
  "/select-company": "Select Company",
  "/selectcompny": "Select Company",
  "/home": "Dashboard",
  "/Booking": "Bookings",
  "/Dutyslip": "Duty Slips",
  "/invoicedetails": "Invoice Details",
  "/addinvoice": "New Invoice",
  "/invoice": "Invoices",
  "/product": "Product List",
  "/taxes": "Taxes",
  "/user": "User Management",
  "/users": "Users",
  "/masterdata": "Master Data",
  "/Vehicles": "Vehicles",
  "/AddVehicles": "Add Vehicle",
  "/UpdateVehicles": "Update Vehicle",
  "/vehicletype": "Vehicle Types",
  "/showvehicletype": "Vehicle Types",
  "/GroupMaster": "Group Master",
  "/AddGroup": "Add Group",
  "/Ledger": "Ledger Master",
  "/ShowLedger": "Ledger Master",
  "/AddLedger": "Add Ledger",
  "/UpdateLedger": "Update Ledger",
  "/fares": "Fares",
  "/showfares": "Fares",
  "/servisemaster": "Service Master",
  "/gst-tax-register": "GST Tax Register",
  "/vouchers": "Vouchers",
  "/ledger-report": "Account Ledger",
  "/trial-balance": "Trial Balance",
  "/reports/trial-balance": "Trial Balance",
  "/monthly-ledger-summary": "Monthly Ledger Summary",
  "/reports/monthly-ledger-summary": "Monthly Ledger Summary",
  "/ledger-transactions": "Ledger Transactions",
  "/reports/ledger-transactions": "Ledger Transactions",
  "/group-ledger-summary": "Group Ledger Summary",
  "/reports/group-ledger-summary": "Group Ledger Summary",
  "/group-summary": "Group Summary",
  "/reports/group-summary": "Group Summary",
  "/journal-register": "Journal Register",
  "/reports/journal-register": "Journal Register",
  "/day-book": "Day Book",
  "/reports/day-book": "Day Book",
  "/cash-book": "Cash Book",
  "/reports/cash-book": "Cash Book",
  "/bank-book": "Bank Book",
  "/reports/bank-book": "Bank Book",
  "/purchase-register": "Purchase Register",
  "/reports/purchase-register": "Purchase Register",
  "/sales-register": "Sales Register",
  "/reports/sales-register": "Sales Register",
  "/profit-loss": "Profit & Loss",
  "/reports/profit-loss": "Profit & Loss",
  "/pnl-statement": "Profit & Loss",
  "/reports/pnl-statement": "Profit & Loss",
  "/balance-sheet": "Balance Sheet",
  "/reports/balance-sheet": "Balance Sheet",
  "/voucher-entry": "Voucher Entry",
  "/transactions/voucher-entry": "Voucher Entry",
  "/modify-voucher": "Modify Voucher",
  "/transactions/modify-voucher": "Modify Voucher",
  "/configuration": "Settings",
  "/settings": "Settings",
  "/import-ledger": "Import Ledger",
};

const PageTitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase();
    let title = null;
    for (const [key, val] of Object.entries(ROUTE_TITLES)) {
      if (key.toLowerCase() === path) {
        title = val;
        break;
      }
    }
    document.title = title ? `${title} | eTour` : "eTour";
  }, [location]);

  return null;
};

const ProtectedRoute = ({ children }) => {
  const userId = localStorage.getItem("userId");
  if (!userId) {
    return <Navigate to="/" replace />;
  }
  return children;
};

function Service() {
  return (
    <CompanyProvider>
      <PageTitleManager />
      <Routes>
        {/* Auth Routes */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/" element={<Signin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<OtpVerification />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* ✅ Company selection route (only accessible after login) */}
        <Route
          path="/select-company"
          element={
            <ProtectedRoute>
              <SelectCompany />
            </ProtectedRoute>
          }
        />

        {/* All app routes (protected inside Layout) */}
        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >

          <Route path="/home" element={<Dashboard />} />
          <Route path="/invoicedetails" element={<InvoicesDetails />} />
          <Route path="/addinvoice" element={<Addinvoice />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/product" element={<ProductList />} />
          <Route path="/taxes" element={<Taxes />} />
          {/* <Route path="/payment" element={<Payment />} /> */}
          <Route path="/user" element={<User />} />
          <Route path="/masterdata" element={<MasterData />} />
          <Route path="/getdata" element={<Getdata />} />
          <Route path="/updatedata" element={<Updatedata />} />
          <Route path="/users" element={<Users />} />
          <Route path="/selectdata" element={<Selectdata />} />
          <Route path="/resetpass/:id/:name" element={<Resetpass />} />
          <Route path="/compney" element={<Compney />} />
          <Route path="/selectcompny" element={<Selectcompny />} />
          <Route path="/compupdatedata" element={<CompUpdateData />} />
          <Route path="/deletdata" element={<Deletdata />} />
          <Route path="/newusers" element={<NewUser />} />
          <Route path="/updateuser" element={<Updateuser />} />
          <Route path="/servisemaster" element={<Servisemaster />} />
          <Route path="/servicemaster" element={<Servisemaster />} />
          <Route path="/vehicletype" element={<VehicleType />} />
          <Route path="/showvehicletype" element={<ShowVehicleTypes />} />
          <Route path="/fares" element={<Fares />} />
          <Route path="/showfares" element={<Showfares />} />
          <Route path="/payable" element={<Showfares />} />
          <Route path="/receivable" element={<Showfares />} />
          <Route path="/showservice" element={<Showservice />} />
          <Route path="/updateservice" element={<Updateservice />} />
          <Route path="/updatefares" element={<Updatefares />} />
          <Route path="/updateservicemast" element={<UpdateServiceMast />} />
          <Route path="/updatevehile" element={<UpdateVehicle />} />
          <Route path="/Addfare" element={<Fares />} />
          <Route path="/Updatefare" element={<Fares />} />
          <Route path="/GroupMaster" element={<GroupMaster />} />
          <Route path="/AddGroup" element={<AddGroup />} />
          <Route path="/updategroup" element={<UpdateGroup />} />
          <Route path="/Ledger" element={<ShowLedger />} />
          <Route path="/AddLedger" element={<AddLedger />} />
          <Route path="/ShowLedger" element={<ShowLedger />} />
          <Route path="/UpdateLedger" element={<UpdateLedger />} />
          <Route path="/Vehicles" element={<Vehicles />} />
          <Route path="/AddVehicles" element={<AddVehicles />} />
          <Route path="/UpdateVehicles" element={<UpdateVehicles />} />
          <Route path="/Booking" element={<Booking />} />
          <Route path="/Dutyslip" element={<DutySlip />} />




          <Route path="/BillsInvoice" element={<BillsInvoice />} />
          <Route path="/modify-invoice" element={<BillsInvoice />} />
          <Route path="/modify-invoice/*" element={<BillsInvoice />} />
          {/* Wildcard route: handles invoice numbers with slashes (e.g. DTT/8463/2026-2027) */}
          <Route
            path="/invoice-details/:CompID/*"
            element={<InvoiceDetails />}
          />
          <Route path="/ViewInvoice" element={<ViewInvoice />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/gst-tax-register" element={<GstTaxRegister />} />
          <Route path="/vouchers" element={<VoucherRegister />} />
          <Route path="/ledger-report" element={<AccountLedgerReport />} />
          <Route path="/trial-balance" element={<TrialBalanceReport />} />
          <Route path="/reports/trial-balance" element={<TrialBalanceReport />} />
          <Route path="/monthly-ledger-summary" element={<MonthlyLedgerSummary />} />
          <Route path="/reports/monthly-ledger-summary" element={<MonthlyLedgerSummary />} />
          <Route path="/ledger-transactions" element={<LedgerTransactions />} />
          <Route path="/reports/ledger-transactions" element={<LedgerTransactions />} />
          <Route path="/group-ledger-summary" element={<GroupLedgerSummary />} />
          <Route path="/reports/group-ledger-summary" element={<GroupLedgerSummary />} />
          <Route path="/group-summary" element={<GroupSummary />} />
          <Route path="/reports/group-summary" element={<GroupSummary />} />
          <Route path="/journal-register" element={<JournalRegister />} />
          <Route path="/reports/journal-register" element={<JournalRegister />} />
          <Route path="/day-book" element={<DayBook />} />
          <Route path="/reports/day-book" element={<DayBook />} />
          <Route path="/cash-book" element={<CashBook />} />
          <Route path="/reports/cash-book" element={<CashBook />} />
          <Route path="/bank-book" element={<BankBook />} />
          <Route path="/reports/bank-book" element={<BankBook />} />
          <Route path="/purchase-register" element={<PurchaseRegister />} />
          <Route path="/reports/purchase-register" element={<PurchaseRegister />} />
          <Route path="/sales-register" element={<SalesRegister />} />
          <Route path="/reports/sales-register" element={<SalesRegister />} />
          <Route path="/profit-loss" element={<ProfitLoss />} />
          <Route path="/reports/profit-loss" element={<ProfitLoss />} />
          <Route path="/pnl-statement" element={<ProfitLoss />} />
          <Route path="/reports/pnl-statement" element={<ProfitLoss />} />
          <Route path="/balance-sheet" element={<BalanceSheet />} />
          <Route path="/reports/balance-sheet" element={<BalanceSheet />} />
          <Route path="/transactions/voucher-entry" element={<VoucherEntry />} />
          <Route path="/voucher-entry" element={<VoucherEntry />} />
          <Route path="/transactions/modify-voucher" element={<VoucherEntry />} />
          <Route path="/modify-voucher" element={<VoucherEntry />} />
          <Route path="/configuration" element={<Configuration />} />
          <Route path="/settings" element={<Configuration />} />
          <Route path="/master/configuration" element={<Configuration />} />
          <Route path="/import-ledger" element={<ImportLedger />} />
          <Route path="/utility/import-ledger" element={<ImportLedger />} />
        </Route>

      </Routes>
      {/* <Footer/> */}
    </CompanyProvider>
  );
}

export default Service;